import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ButtonComponent from '../../../../button/ButtonComponent';

import { useCheckoutFlow } from './CheckoutFlowContext';

const CheckoutFlowPayButton = ({ i18n }) => {
    const { isValid, submitting, handlePay } = useCheckoutFlow();

    return (
        <ButtonComponent
            color="main"
            cssClass="nextStepButton pay-button"
            text={i18n.PAY_BUTTON}
            disabled={!isValid || submitting}
            onClick={handlePay}
        />
    );
};

CheckoutFlowPayButton.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => ({
    i18n: state.i18n.CHECKOUT.FLOW
});

export default connect(mapStateToProps)(CheckoutFlowPayButton);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/payment-methods/checkout-flow/CheckoutFlowPayButton.js